import { PaginatedProvidersSchema } from '@/apis/providers/requests'
import { Provider } from 'react-redux'
import { z } from 'zod'

export const ProviderApplicationSchema = z.object({
  id: z.number(),
  provider_id: z.number(),
  applicant_first_name: z.string().nullable(), // Nullable if it might be `null`
  provider_categories: z.array(
    z.object({
      id: z.number(),
      provider_application_id: z.number(),
      global_provider_category_id: z.number(),
      global_provider_category: z.object({
        id: z.number(),
        name: z.string(),
      }),
    })
  ),
})

export const ProviderSchema = z.object({
  id: z.number(),
  name: z.string(),
  email: z.string(),
  location: z.string().nullable(),
})

export const ProvidersSchema = z.array(ProviderSchema)

export type Provider = z.infer<typeof ProviderSchema>
export type Providers = z.infer<typeof ProvidersSchema>
export type ProvidersResponse = z.infer<typeof PaginatedProvidersSchema>

export const PaymentCategorySchema = z.object({
  id: z.number(),
  name: z.string(),
})

export const PaymentCategoriesSchema = z.array(PaymentCategorySchema)
export type PaymentCategories = z.infer<typeof PaymentCategoriesSchema>

const PendingPaymentSchema = z.object({
  id: z.number(),
  status: z.string(),
  type: z.string(),
  total_amount: z.number(),
  amount: z.number(),
  created_datetime: z.string(),
  provider_name: z.string().nullable(),
})

const PurseSchema = z.object({
  id: z.number().int().positive(),
  status: z.number().int(),
  name: z.string(),
  global_purse_type_id: z.number().int().positive(),
  program_id: z.number().int().positive(),

  is_funded: z.number().transform((value) => {
    return value === 1
  }),
  student_id: z.number().int().positive(),
  total: z.number(),
  student_name: z.string(),
  balance: z.number(),
  balance_available: z.number(),
  balance_frozen: z.number(),
  reimbursement_restricted: z.number().transform((value) => {
    // if value is === 1 this wallet is restricted from reimbursement and we return true instead of a number
    return value === 1
  }),
  pending_payments: z.array(PendingPaymentSchema),
  created_datetime: z.string(),
  last_datetime: z.string(),
})

// Define the array schema (for multiple purses)
const PursesArraySchema = z.array(PurseSchema)

// Type inference
export type Purse = z.infer<typeof PurseSchema>
export type PursesArray = z.infer<typeof PursesArraySchema>

export { PurseSchema, PursesArraySchema }
